var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-sm":"","align-content-space-between":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((this.players),function(ex,k){return _c('Player',{key:k,attrs:{"data":ex}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }